import React from 'react';

export default function SupporterPage() {
  return (
    <div>
      <h1 className="iasv-page-title">Espace supporter</h1>
      <p className="iasv-page-subtitle">Suivez votre club, ses résultats et ses temps forts.</p>
      <div className="iasv-card">
        <p style={{ color: 'var(--iasv-text-muted)', margin: 0 }}>Module à brancher sur les classements / résultats DOFA.</p>
      </div>
    </div>
  );
}
